"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SvgIcon = void 0;
var react_1 = __importDefault(require("react"));
exports.SvgIcon = react_1.default.forwardRef(function SvgIcon(props, ref) {
    var children = props.children, className = props.className, _a = props.component, Component = _a === void 0 ? 'svg' : _a, htmlColor = props.htmlColor, titleAccess = props.titleAccess, _b = props.viewBox, viewBox = _b === void 0 ? '0 0 24 24' : _b, other = __rest(props, ["children", "className", "component", "htmlColor", "titleAccess", "viewBox"]);
    return (react_1.default.createElement(Component, __assign({ className: className, focusable: "false", viewBox: viewBox, color: htmlColor, "aria-hidden": titleAccess ? undefined : true, role: titleAccess ? 'img' : undefined, ref: ref }, other),
        children,
        titleAccess ? react_1.default.createElement("title", null, titleAccess) : null));
});
